import {
    Activity,
    ArrowRight,
    Server,
    ShieldCheck,
} from 'lucide-react';

import { Link } from 'react-router-dom';

/**
 * Pied de page principal Helvedoc.
 *
 * Cette version utilise React Router et ne dépend plus d'Inertia/usePage.
 */
export function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="relative mt-auto overflow-hidden bg-[linear-gradient(180deg,#F7F7F8_0%,#F1F2F4_100%)] text-[#1A1D23]">
            {/* Bordure supérieure */}
            <div className="h-px w-full bg-gradient-to-r from-[#b20303]/0 via-[#b20303]/60 to-[#b20303]/0" />

            {/* Grain de fond */}
            <div
                className="pointer-events-none absolute inset-0 opacity-[0.02] mix-blend-multiply"
                style={{
                    backgroundImage:
                        "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")",
                }}
            />

            <div className="relative mx-auto max-w-7xl px-6 py-12">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4 lg:gap-0 lg:divide-x lg:divide-[#DDE0E5]">

                    {/* PLATEFORME */}
                    <div className="lg:pr-7">
                        <h3 className="mb-4 flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.26em] text-[#4B5160]">
                            <span className="h-px w-4 bg-[#b20303]" />
                            Plateforme
                        </h3>

                        <div className="rounded-2xl border border-[#E4E6EA] bg-gradient-to-b from-white to-[#FAFAFA] p-5 shadow-[0_1px_2px_rgba(15,23,42,0.03)] transition-all duration-300 hover:border-[#D8DCE2] hover:shadow-[0_6px_18px_rgba(15,23,42,0.05)]">
                            <p className="mb-4 text-[12.5px] leading-[1.5] text-[#3C4149]">
                                Helvedoc est une plateforme privée d&apos;assistance
                                et de fourniture de documents d&apos;entreprises,
                                totalement indépendante de tout organisme public
                                et du Registre du Commerce (RC) suisse.
                            </p>

                            <div className="space-y-2.5">
                                <div className="flex items-center gap-2.5">
                                    <div className="h-[3px] w-[3px] shrink-0 rounded-full bg-[#b20303]" />

                                    <span className="text-[12px] font-medium leading-tight text-[#3C4149]">
                                        Extrait RC et documents officiels
                                    </span>
                                </div>

                                <div className="flex items-center gap-2.5">
                                    <div className="h-[3px] w-[3px] shrink-0 rounded-full bg-[#b20303]" />

                                    <span className="text-[12px] font-medium leading-tight text-[#3C4149]">
                                        Accompagnement juridique & comptable
                                    </span>
                                </div>

                                <div className="flex items-center gap-2.5">
                                    <div className="h-[3px] w-[3px] shrink-0 rounded-full bg-[#b20303]" />

                                    <span className="text-[12px] font-medium leading-tight text-[#3C4149]">
                                        Veille réglementaire et alertes
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* GARANTIES TECHNIQUES */}
                    <div className="lg:px-7">
                        <h3 className="mb-4 flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.26em] text-[#4B5160]">
                            <span className="h-px w-4 bg-[#b20303]" />
                            Garanties techniques
                        </h3>

                        <div className="grid grid-cols-3 gap-2.5">

                            {/* Infrastructure */}
                            <div className="group flex flex-col items-center rounded-xl border border-[#E4E6EA] bg-white px-2 py-4 shadow-[0_1px_2px_rgba(15,23,42,0.03)] transition-all duration-500 hover:-translate-y-0.5 hover:border-[#D8DCE2] hover:shadow-[0_8px_20px_rgba(15,23,42,0.06)]">
                                <div className="mb-2.5 flex h-9 w-9 items-center justify-center rounded-lg bg-[#F1F2F4] text-[#b20303] transition-all duration-500 group-hover:bg-gradient-to-br group-hover:from-[#c40404] group-hover:to-[#7a0202] group-hover:text-white group-hover:shadow-[0_6px_14px_rgba(178,3,3,0.28)]">
                                    <Server
                                        className="h-[16px] w-[16px]"
                                        strokeWidth={1.8}
                                    />
                                </div>

                                <span className="text-[10px] font-semibold tracking-wide text-[#3C4149]">
                                    Infrastructure
                                </span>
                            </div>

                            {/* 24/7 */}
                            <div className="group flex flex-col items-center rounded-xl border border-[#E4E6EA] bg-white px-2 py-4 shadow-[0_1px_2px_rgba(15,23,42,0.03)] transition-all duration-500 hover:-translate-y-0.5 hover:border-[#D8DCE2] hover:shadow-[0_8px_20px_rgba(15,23,42,0.06)]">
                                <div className="mb-2.5 flex h-9 w-9 items-center justify-center rounded-lg bg-[#F1F2F4] text-[#b20303] transition-all duration-500 group-hover:bg-gradient-to-br group-hover:from-[#c40404] group-hover:to-[#7a0202] group-hover:text-white group-hover:shadow-[0_6px_14px_rgba(178,3,3,0.28)]">
                                    <Activity
                                        className="h-[16px] w-[16px]"
                                        strokeWidth={1.8}
                                    />
                                </div>

                                <span className="text-[10px] font-semibold tracking-wide text-[#3C4149]">
                                    24/7
                                </span>
                            </div>

                            {/* Sécurité */}
                            <div className="group flex flex-col items-center rounded-xl border border-[#E4E6EA] bg-white px-2 py-4 shadow-[0_1px_2px_rgba(15,23,42,0.03)] transition-all duration-500 hover:-translate-y-0.5 hover:border-[#b20303]/30 hover:shadow-[0_8px_20px_rgba(235,0,0,0.08)]">
                                <div className="mb-2.5 flex h-9 w-9 items-center justify-center rounded-lg bg-[#F1F2F4] text-[#b20303] transition-all duration-500 group-hover:bg-gradient-to-br group-hover:from-[#c40404] group-hover:to-[#7a0202] group-hover:text-white group-hover:shadow-[0_6px_14px_rgba(178,3,3,0.28)]">
                                    <ShieldCheck
                                        className="h-[16px] w-[16px]"
                                        strokeWidth={1.8}
                                    />
                                </div>

                                <span className="text-[10px] font-semibold tracking-wide text-[#3C4149]">
                                    Cryptées
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* INFORMATIONS LÉGALES */}
                    <div className="lg:px-7">
                        <h3 className="mb-4 flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.26em] text-[#4B5160]">
                            <span className="h-px w-4 bg-[#b20303]" />
                            Informations légales
                        </h3>

                        <div className="space-y-3.5">
                            <div>
                                <div className="mb-0.5 text-[9.5px] font-bold uppercase tracking-[0.1em] text-[#6B7280]">
                                    Société
                                </div>

                                <div className="text-[12.5px] font-medium text-[#1A1D23]">
                                    Tosevar Ltd.
                                </div>
                            </div>

                            <div>
                                <div className="mb-0.5 text-[9.5px] font-bold uppercase tracking-[0.1em] text-[#6B7280]">
                                    Structure juridique
                                </div>

                                <div className="text-[12.5px] font-medium text-[#1A1D23]">
                                    Private Limited Company
                                </div>
                            </div>

                            <div>
                                <div className="mb-0.5 text-[9.5px] font-bold uppercase tracking-[0.1em] text-[#6B7280]">
                                    Siège social
                                </div>

                                <div className="text-[12.5px] font-medium leading-[1.4] text-[#1A1D23]">
                                    128, City Road, London, EC1V 2NK, United
                                    Kingdom
                                </div>
                            </div>

                            <div className="grid grid-cols-2 gap-3 border-t border-[#E4E6EA] pt-3.5">
                                <div>
                                    <div className="mb-0.5 text-[9.5px] font-bold uppercase tracking-[0.1em] text-[#6B7280]">
                                        Company number
                                    </div>

                                    <div className="text-[12.5px] font-medium text-[#1A1D23]">
                                        17305630
                                    </div>
                                </div>

                                <div>
                                    <div className="mb-0.5 text-[9.5px] font-bold uppercase tracking-[0.1em] text-[#6B7280]">
                                        Incorporation
                                    </div>

                                    <div className="text-[12.5px] font-medium text-[#1A1D23]">
                                        29 juin 2026
                                    </div>
                                </div>
                            </div>

                            <div className="border-t border-[#E4E6EA] pt-3.5">
                                <div className="mb-0.5 text-[9.5px] font-bold uppercase tracking-[0.1em] text-[#6B7280]">
                                    Autorité d&apos;enregistrement
                                </div>

                                <div className="text-[12.5px] font-medium leading-[1.4] text-[#1A1D23]">
                                    Registrar of Companies for England and Wales
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* RESSOURCES */}
                    <div className="lg:pl-7">
                        <h3 className="mb-4 flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.26em] text-[#4B5160]">
                            <span className="h-px w-4 bg-[#b20303]" />
                            Ressources
                        </h3>

                        <div className="rounded-2xl border border-[#E4E6EA] bg-white p-1.5 shadow-[0_1px_2px_rgba(15,23,42,0.03)]">
                            <ul className="space-y-0.5">
                                <FooterLink
                                    href="/mentions-legales"
                                    label="Mentions Légales"
                                />

                                <FooterLink
                                    href="/conditions-generales"
                                    label="Conditions Générales de Vente CGV"
                                />

                                <FooterLink
                                    href="/confidentialite"
                                    label="Politique de Confidentialité"
                                />
                            </ul>
                        </div>

                        <p className="mt-3 px-1 text-[11px] leading-[1.5] text-[#6B7280]">
                            Informations réglementaires et documents contractuels
                            accessibles à tout moment.
                        </p>
                    </div>
                </div>

                {/* BOTTOM BAR */}
                <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-[#E4E6EA] pt-6 sm:flex-row">
                    <p className="text-[11px] font-medium tracking-wide text-[#6B7280]">
                        © {currentYear}{' '}
                        <span className="font-semibold text-[#1A1D23]">
                            Tosevar Ltd.
                        </span>{' '}
                        Tous droits réservés.
                    </p>

                    <div className="flex items-center gap-2 text-[11px] font-medium text-[#4B5160]">
                        <span className="h-1 w-1 rounded-full bg-[#b20303]" />

                        <span>Données certifiées & sécurisées</span>
                    </div>
                </div>
            </div>
            

        </footer>
    );
}

type FooterLinkProps = {
    href: string;
    label: string;
};

function FooterLink({ href, label }: FooterLinkProps) {
    return (
        <li>
            <Link
                to={href}
                className="group flex items-center justify-between rounded-xl px-3.5 py-3 text-[12px] font-medium leading-snug text-[#3C4149] transition-all duration-300 hover:bg-[#F7F7F8] hover:text-[#1A1D23]"
            >
                <span>{label}</span>

                <ArrowRight
                    className="h-3.5 w-3.5 shrink-0 text-[#b20303] opacity-0 transition-all duration-300 group-hover:translate-x-1 group-hover:opacity-100"
                    strokeWidth={2}
                />
            </Link>
        </li>
    );
}

export default Footer;